module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/605de00c0d558339efa3bbc72ba44d5c.png";